export const AddressHelper = {
  getDefaultAddress () {
    return {
      line1: '',
      line2: '',
      line3: '',
      town: '',
      county: '',
      postCode: ''
    }
  },
  // This address validator can only be used in the client onboarding feature,
  // as the address is not a required field for completing registration.
  getRegistrationAddressValidator () {
    return {
      line1: '',
      postCode: '',
      isValid: true,
      check (address) {
        const hasAnyValue = Object.values(address).some(value => !!value)

        if (!hasAnyValue) {
          this.line1 = ''
          this.postCode = ''
          this.isValid = true
          return
        }

        this.line1 = address.line1 ? '' : 'Please enter line 1'
        this.postCode = address.postCode ? '' : 'Please enter postcode'
        this.isValid = !!(address.line1 && address.postCode)
      }
    }
  },
  getAddressValidator () {
    return {
      line1: '',
      postCode: '',
      isValid: false,
      check (address) {
        this.line1 = address?.line1 ? '' : 'Please enter line 1'
        this.postCode = address?.postCode ? '' : 'Please enter postcode'
        this.isValid = !!(address?.line1 && address?.postCode)
      }
    }
  },
  getAddressLines (address) {
    return address
      ? [address.line1, address.line2, address.line3, address.town, address.county, address.postCode].filter(o => o)
      : []
  }
}
